import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/typography/index.shared';

const Label = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.LABEL.DEFAULT}px;
`;

export default Label;
